import React from "react";
import Draggable from "react-draggable";

export default class CustomSignatureRedirectDraggable extends React.Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
    this.resizeRef = React.createRef();
  }

  state = {
    controlledPosition: {
      x: this.props.textPosition.x,
      y: this.props.textPosition.y,
    },
    infoHidden: false,
    isResizing: false,
    currentSize: this.props.qrSize || 50,
    ratio: 1,
  };

  componentDidMount() {
    if (!this.props.qrImage) return;
    const img = new Image();
    img.src = `data:image/*;base64,${this.props.qrImage}`;
    img.onload = () => {
      this.setState({ ratio: img.width / img.height || 1 });
    };
  }

  onControlledDrag = (_, position) => {
    const { x, y } = position;
    this.props.setTextPosition({ x, y });
    this.setState({ controlledPosition: { x, y } });
  };

  handleResizeStart = (e) => {
    e.stopPropagation();
    this.setState({ isResizing: true });

    const startX = e.clientX;
    const startY = e.clientY;
    const startSize = this.state.currentSize;

    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const deltaY = moveEvent.clientY - startY;
      const delta = Math.max(deltaX, deltaY);

      const newSize = Math.max(30, Math.min(300, startSize + delta));

      this.setState({ currentSize: newSize });

      if (this.props.setQrSize) {
        this.props.setQrSize(newSize);
      }
    };

    const handleMouseUp = () => {
      this.setState({ isResizing: false });
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.textPosition.x !== prevProps.textPosition.x ||
      this.props.textPosition.y !== prevProps.textPosition.y
    ) {
      this.setState({
        controlledPosition: {
          x: this.props.textPosition.x,
          y: this.props.textPosition.y,
        },
        infoHidden: true,
      });
    }

    if (
      this.props.qrSize !== prevProps.qrSize &&
      this.props.qrSize !== this.state.currentSize
    ) {
      this.setState({ currentSize: this.props.qrSize });
    }
  }

  render() {
    const { controlledPosition, infoHidden, currentSize, ratio } = this.state;
    const width = currentSize;
    const height = currentSize / (ratio || 1);

    return (
      <Draggable
        nodeRef={this.nodeRef}
        axis="both"
        bounds="parent"
        handle=".signature-handle"
        scale={1}
        position={controlledPosition}
        onDrag={this.onControlledDrag}
        disabled={this.props.isDetailMode}
      >
        <div className="absolute bottom-0 left-0" ref={this.nodeRef}>
          <div className="relative w-fit">
            <div className="mt-1 flex justify-center w-full bg-white p-[2px]">
              {this.props.qrImage ? (
                <img
                  alt="Signature"
                  src={`data:image/*;base64,${this.props.qrImage}`}
                  className={`pointer-events-none select-none box-border object-contain ${
                    this.props.isDetailMode ? "" : "border border-emerald-600"
                  }`}
                  style={{ width, height }}
                />
              ) : (
                <div
                  className="flex items-center justify-center text-[8px] text-gray-500 border border-dashed border-emerald-600"
                  style={{ width, height }}
                >
                  No Specimen
                </div>
              )}
            </div>

            {!this.props.isDetailMode && (
              <div
                className="absolute bottom-0 right-0 w-4 h-4 bg-emerald-600 cursor-se-resize z-10"
                onMouseDown={this.handleResizeStart}
                ref={this.resizeRef}
                style={{ borderTopLeftRadius: "2px" }}
              >
                <div className="absolute bottom-0 right-0 w-full h-full flex items-end justify-end p-0.5">
                  <div className="w-1.5 h-1.5 border-b-2 border-r-2 border-white"></div>
                </div>
              </div>
            )}

            <div
              className={`absolute flex justify-center items-center w-full h-full top-0 left-0 bg-transparent signature-handle cursor-move ${
                this.props.isDetailMode ? "hidden" : ""
              }`}
            >
              <div
                className={`bg-white w-16 text-emerald-600 text-xs text-center font-semibold select-none ${
                  infoHidden || this.props.isDetailMode ? "hidden" : ""
                }`}
              >
                Drag
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    );
  }
}
